import PlurallClient from 'plurall-client'
import { getToken } from 'utils'

const BASE_PATH = '/networks/0/roles/0/users/0'

class Client {
  constructor(config) {
    this.client = new PlurallClient({
      accessToken: getToken(),
      accept: config ? config.accept : 'vnd.plurall.api.v2+json',
      apiURL: process.env.REACT_APP_PLURALL_API_URL,
      graphqlURL: process.env.REACT_APP_SOMOS_GRAPHQL_URL,
      disableAutoCamelize: false,
    })

    this.getProfile = this.client.getProfile
  }

  get = ({ path, params }) =>
    this.client.get(`${BASE_PATH}${path}`, { params }).then(response => response)

  post = (path, body) => this.client.post(`${BASE_PATH}${path}`, body)

  getDisciplines = () => this.get({ path: '/disciplines' })

  getFilters = params =>
    this.client.get(`${this.client.config.apiURL}/questions/filters`, { params })

  getQuestions = params => this.client.get(`${this.client.config.apiURL}/questions`, { params })

  getQuestion = questionId =>
    this.client.get(`${this.client.config.apiURL}/questions/${questionId}`)

  createQuestion = question => this.post('/questions', question)
}

export default Client
